import type { DataOption } from '../model/types'

import React from 'react'

import { Tag } from '@/shared/components/ui/tag'

export function BasicChipField({
	value,
	choices,
}: {
	value: string | null | undefined
	choices: Record<string, DataOption>
}) {
	if (!value) {
		return <div className='flex items-center gap-1'>-</div>
	}
	const items = getChoice(value, choices || [])

	return (
		<div className='flex items-center gap-1'>
			{items?.length > 0
				? items.map((choice, index) => (
						<Tag
							variant={choice.variant as any}
							key={`${String(value)}-${index}`}
						>
							{choice.icon}
							{choice.label}
						</Tag>
					))
				: '-'}
		</div>
	)
}

function getValueAsArray(value?: any) {
	return Array.isArray(value) ? value : value !== undefined ? [value] : []
}

export function getChoice<T>(value?: any, choices?: Record<string, T>): T[] {
	const items = getValueAsArray(value)

	return items?.length > 0
		? items.map((value) => {
				if (choices?.[value]) {
					return choices?.[value]
				} else if (value === null || value === undefined) {
					return { label: value, value } as T
				} else {
					return { label: value, value } as T
				}
			})
		: items
}
